export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "8601b5b.worker.js");
}
